var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"column":"","wrap":""}},[_c('v-flex',[_c('h1',{staticClass:"display-3"},[_vm._v("Observaciones")])])],1),_vm._v(" "),_c('v-layout',[_c('v-flex',{attrs:{"xs12":"","lg8":""}},[_c('div',{attrs:{"id":"editor"}})])],1)],1)}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-01950366","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/pages/calidad/no_conformidad/obs.vue
// module id = GVvt
// module chunks = 0